/** @prettier */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '@xanadu/ui-shared/components/widgets/Button';
import { dispatch as gtmDispatch } from '@xanadu/ui-shared/interfaces/googleTagManager';
import { userVirtualPageView as gtmUserVirtualPageView } from '@xanadu/ui-shared/interfaces/googleTagManager/actions';
import { track } from '@xanadu/ui-shared/interfaces/woopra';
import showLiveSupport from '@xanadu/ui-shared/utils/showLiveSupport';

import styles from './PreviousLoggedIn.module.scss';

const PreviousLoggedIn = ({ onRequestClose, loginRequest, registrationRequest }) => {
  const currentUrl = window.location.href;

  const handleRegister = () => {
    onRequestClose();
    setTimeout(() => {
      registrationRequest({ show: true, promoRegistrationImage: null, checked: true });

      // GTM
      gtmDispatch(
        gtmUserVirtualPageView({
          currentUrl,
          eventName: 'Reg Process',
          virtualPageTitle: 'Step 1 - account',
          virtualPageURL: '/reg/step1/',
          previousURL: '/login/',
          clickSource: { clickSource: `mb-join-now-button_${location.href}` },
        })
      );

      track('Registration', 'Registration opened', {
        description: 'login',
      });
    }, 250);
  };

  const mainClass = classNames({
    [styles.main]: true,
  });

  return (
    <div className={mainClass}>
      <div className={styles.content}>
        <div className={styles.modalTitle}>Welcome back to Matchbook</div>
        <div className={styles.modalContent}>
          <div>
            {
              'It looks like you may already have an account with Matchbook. Only one account is allowed per customer.'
            }
          </div>
          <div>
            {
              'Please log in below. If you have forgotten your password, this can be reset from the login screen.'
            }
          </div>
          <div>
            <span>
              Need more help?&nbsp;
              <button className={styles.helpButton} onClick={showLiveSupport}>
                Speak to our customer service team.
              </button>
            </span>
          </div>
        </div>
        <div className={styles.rowContainer}>
          <div className={styles.buttonContainer}>
            <Button
              sizeType="regular"
              buttonType="flat"
              className={styles.button}
              onClick={handleRegister}
            >
              Continue to Register
            </Button>
            <Button
              className={styles.button}
              buttonType="primary"
              sizeType={'medium'}
              disabled={false}
              success={false}
              dataHook="login-top"
              href="/login"
              onClick={(e) => {
                e.preventDefault();
                // GTM
                gtmDispatch(
                  gtmUserVirtualPageView({
                    currentUrl,
                    eventName: 'Login Request',
                    virtualPageTitle: 'Log In / Sign Up',
                    virtualPageURL: '/login/',
                    previousURL: `${location.href}`,
                    clickSource: { clickSource: `mb-join-now-button_${location.href}` },
                  })
                );

                track('Marketing', 'Login opened', {
                  description: 'header',
                });

                loginRequest();
              }}
            >
              Log In
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

PreviousLoggedIn.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  loginRequest: PropTypes.func.isRequired,
  registrationRequest: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

export default PreviousLoggedIn;
